import { Box, HStack } from 'native-base';
import moment from 'moment';

import { Text } from '@pimm/base';
import { SalesDaypart } from '../types';

type TimeSlotsProps = {
  tableData?: Partial<SalesDaypart>;
};

export const TimeSlots = ({ tableData }: TimeSlotsProps) => {
  return (
    <HStack flex={1}>
      {tableData?.blocks?.map(_ => (
        <Box
          key={_.startTime.toISOString()}
          flex={1}
          alignItems="center"
          justifyContent="center"
          py={0.5}
          borderLeftWidth={1}
          borderColor="gray.200"
        >
          <Text size={{ base: 'xs', xl: 'sm' }} fontWeight={500} color="black" textAlign="center">
            {moment(_.startTime).format(tableData!.blocks!.length > 16 ? 'ha' : 'h:mma')}
          </Text>
        </Box>
      ))}
    </HStack>
  );
};
